import {DomainObject} from 'shared/DomainObject';
import { observable, action, makeObservable } from 'mobx';

class Location extends DomainObject {
  id;
  name = '';
  regionCode;
  countryCode;
  address;
  city;
  postalCode;

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable,
      regionCode: observable,
      countryCode: observable,
      address: observable,
      city: observable,
      postalCode: observable,
      updateCountry: action
    });

    this.merge(other);
  }

  updateCountry(countryCode) {
    if (this.countryCode !== countryCode) {
      this.regionCode = '';
    }

    this.countryCode = countryCode;
  }

  static defaultOrderAttribute() {
    return 'name';
  }
}

export default Location;
